export default __webpack_public_path__ + "static/media/Modo_claro.1fcde335.png";